export default "__VITE_ASSET__278aaf36__"